// Aba direita da conversa por conta (settings.conversation_panel, configurado
// no Super Admin). Sem configuração, a tela fica exatamente como o padrão.
// As chaves são as mesmas de AccountConversationPanel::ITENS_DO_PAINEL no backend.

// Nome da seção na aba direita (useUISettings) => chave da configuração.
export const CHAVE_DA_SECAO = {
  pipeline_kanban: 'secao_kanban',
  scheduled_messages: 'secao_mensagens_agendadas',
  conversation_actions: 'secao_acoes',
  macros: 'secao_macros',
  conversation_info: 'secao_informacoes',
  contact_attributes: 'secao_atributos_contato',
  contact_notes: 'secao_notas',
  previous_conversation: 'secao_conversas_anteriores',
  conversation_participants: 'secao_participantes',
};

export const itemOcultoNoPainel = (configuracao, ehAdministrador, chave) => {
  const ocultos = ehAdministrador
    ? configuracao?.ocultos_para_admins
    : configuracao?.ocultos_para_agentes;
  return Array.isArray(ocultos) && ocultos.includes(chave);
};

export const secaoOcultaNoPainel = (configuracao, ehAdministrador, nome) =>
  Boolean(CHAVE_DA_SECAO[nome]) &&
  itemOcultoNoPainel(configuracao, ehAdministrador, CHAVE_DA_SECAO[nome]);
